var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless quote-list-view" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            !!_vm.jobNSubJobStages?.length
              ? _c("quote-list-side-menu", {
                  attrs: {
                    "job-stages": _vm.jobNSubJobStages,
                    "reset-values": _vm.resetValuesObj,
                    "include-claims-type": _vm.includeClaimsType,
                  },
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "m-3" }, [
            _c("article", { staticClass: "box" }, [
              _c(
                "div",
                {
                  ref: "quoteListing",
                  staticClass:
                    "table-container quotes is-scrollable is-fullwidth entity-summaries-container",
                },
                [
                  _c(
                    "bulma-table",
                    {
                      staticClass: "table is-bordered is-striped is-narrow",
                      attrs: {
                        columns: _vm.columns,
                        "page-index": _vm.filter.pageIndex,
                        "page-size": _vm.filter.pageSize,
                        "total-rows": _vm.totalRows,
                        "is-loading": _vm.isTableLoading,
                        "sort-column": _vm.filter.sortColumn,
                        "sort-order": _vm.filter.sortOrder,
                        "show-pagination": false,
                        "has-sticky-header": true,
                        "sticky-header-top": "0",
                      },
                      on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                    },
                    [
                      _vm._l(_vm.entitySummaries, function (entity, index) {
                        return _c(
                          "tr",
                          {
                            key: entity.quoteId,
                            class: { "is-selected": _vm.selectedRow === index },
                            on: {
                              click: function ($event) {
                                return _vm.highlightSelected(index, $event)
                              },
                            },
                          },
                          [
                            _c(
                              "td",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: entity.quoteId },
                                      append: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(entity.quoteNoRef) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatDateTimezone(
                                    entity.quoteDate,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(entity.regoNo))]),
                            _c("td", [_vm._v(_vm._s(entity.makeModel))]),
                            _c("td", [_vm._v(_vm._s(entity.keyNo))]),
                            _c("td", [_vm._v(_vm._s(entity.claimNo))]),
                            _vm.includeClaimsType
                              ? _c("td", [_vm._v(_vm._s(entity.claimsTypeKey))])
                              : _vm._e(),
                            _c("td", [_vm._v(_vm._s(entity.customerName))]),
                            _c("td", [_vm._v(_vm._s(entity.insurerName))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatDateTimezone(
                                    entity.authorisedDate,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "is-email" }, [
                              _c("div", [_vm._v(_vm._s(entity.quoteStatus))]),
                            ]),
                            _c("td", [
                              _vm._v(" " + _vm._s(entity.jobStageText) + " "),
                              entity.subJobStageText
                                ? _c("span", [
                                    _vm._v(
                                      " - " + _vm._s(entity.subJobStageText)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "tag",
                                  class: [
                                    entity.quotingMethod === "D"
                                      ? "is-success"
                                      : "is-info",
                                  ],
                                },
                                [_vm._v(_vm._s(entity.quotingMethod))]
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "icon",
                                  class: [
                                    entity.invoiceStatus === 1
                                      ? "has-text-warning"
                                      : "has-text-success",
                                  ],
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      entity.invoiceStatus > 0
                                        ? "mdi-check"
                                        : "",
                                    ],
                                  }),
                                ]
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "icon",
                                  class: [
                                    entity.excessInvoiced
                                      ? "has-text-success"
                                      : "has-text-danger",
                                  ],
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      entity.excessInvoiced ? "mdi-check" : "",
                                    ],
                                  }),
                                ]
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "icon",
                                  class: [
                                    entity.active
                                      ? "has-text-success"
                                      : "has-text-danger",
                                  ],
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      entity.active ? "mdi-check" : "mdi-close",
                                    ],
                                  }),
                                ]
                              ),
                            ]),
                            _c(
                              "td",
                              { staticClass: "has-text-centered" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: entity.quoteId },
                                      append: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "button is-primary is-small is-inverted tooltip is-tooltip-left",
                                        attrs: {
                                          "data-tooltip": "Click to edit",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-medium" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-lead-pencil mdi-24px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.isPrintQuoteListModalActive
        ? _c("quote-list-print-modal", {
            attrs: { active: _vm.isPrintQuoteListModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isPrintQuoteListModalActive = $event
              },
              print: _vm.printQuoteList,
              export: _vm.exportToExcel,
              close: _vm.closePrint,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }